import React from 'react'
import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

export const FormMicReturnReasons = (props) => {

    const {
        handleInputChange, return_reason,
    } = props;

    return (
        <Form className="pt-3" role="form" >

            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre de la razón de rechazo <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="return_reason"
                            value={return_reason}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

        </Form>
    )
}
